<div class="aig-claims u-my-8 container u-minheight-vh-60">
  <div class="row u-justify-center">
    <div class="col-12">
      <aig-breadcrumb
        [config]="[{ title: 'Inicio', link: '/area-cliente' }]"
      ></aig-breadcrumb>
    </div>
    <div class="col-12 col-md-8 u-mt-8">
      <section>
        <div class="u-ds-grid u-gap-40">
          <!-- Title -->
          <h1 class="u-color-primary1 u-fw-400 u-h1 u-text-center">
            Gestión de siniestros
          </h1>
          <div class="u-ds-grid u-gap-8" *ngIf="isClaim; else noDataClaims">
            <div *ngIf="isPolicyActive">
              <div class="p-flexce">
                <button class="e-btn--primary u-gap-8 u-fw-500" type="button" (click)="OpenNewClaim()">
                  <p class="">Nuevo siniestro</p>
                  <i class="icon-add u-fs-20"></i>
                </button>
              </div>
            </div>
            <table class="c-table">
              <thead class="u-fs-20">
                  <th>Número de siniestro</th>
                  <th>Fecha de creación</th>
                  <th>Estado</th>
              </thead>
              <tbody>
                <tr *ngFor="let claim of claims">
                    <td class="u-fs-20">
                      {{ claim.numExpediente }}
                    </td>
                    <td>
                      <p class="u-fs-18">
                        {{
                          claim.fechaCreacion
                            | date : "dd-MM-yyyy" : "No disponible"
                        }}
                      </p>
                    </td>
                    <td>
                      <span class="e-badge u-fs-14" [ngClass]="claimState(claim.idEstadoExpediente)">
                      {{ claim.estadoExpediente }}
                      </span>
                    </td>
                    <td>
                      <a class="u-color-primary1 u-fs-16 u-fw-600"
                         (click)="goToDetailsClaim(claim)">
                          <u>
                              Ver detalle
                          </u>
                      </a>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noDataClaims>
            <div class="u-ds-grid u-mb-5">
              <div class="p-flexcc u-mb-3">
                <p>Actualmente no existen siniestros.</p>
              </div>
              <div *ngIf="isPolicyActive">
                <div class="p-flexcc">
                  <button class="e-btn--primary p-flexcc u-fw-500" type="button" (click)="OpenNewClaim()">
                    <p class="aig-header__logout">Abrir nuevo siniestro</p>
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </section>
    </div>
  </div>
</div>

<!-- MODAL QUE SE ABRE SI YA HAY UN SINIESTRO ABIERTO -->
@if(visibleVerSiniestrosModal){
<aig-modal-open-claim (hideModal)="CloseNewClaim()"></aig-modal-open-claim>
}

<!-- MODAL ABRIR SINIESTRO -->
@if(visibleNewClaimModal){
<aig-modal-new-claim
  (hideNewClaimModal)="CloseNewClaim()"
></aig-modal-new-claim>
}
